import { apiRoutes } from "routes";
import FetchHelpers from "utils/FetchHelpers";

export default {
  create(attrs) {
    const url = apiRoutes.campaignAttributionsPath("1");
    return FetchHelpers.post(url, attrs);
  },
};
